/**
 * @license Copyright (c) 2003-2020, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module special-characters/specialcharacterstext
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
/**
 * A plugin that provides special characters for the "Text" category.
 *
 *		ClassicEditor
 *			.create( {
 *				plugins: [ ..., SpecialCharacters, SpecialCharactersText ],
 *			} )
 *			.then( ... )
 *			.catch( ... );
 *
 * @extends module:core/plugin~Plugin
 */
export default class SpecialCharactersText extends Plugin {
    /**
	 * @inheritDoc
	 */
    init() {
        const editor = this.editor;
        const t = editor.t;
        editor.plugins.get('SpecialCharacters').addItems('Text', [
            {
                character: '\u2039',
                title: t('ah')
            },
            {
                character: '\u203A',
                title: t('ai')
            },
            {
                character: '\xAB',
                title: t('aj')
            },
            {
                character: '\xBB',
                title: t('ak')
            },
            {
                character: '\u2018',
                title: t('al')
            },
            {
                character: '\u2019',
                title: t('am')
            },
            {
                character: '\u201C',
                title: t('an')
            },
            {
                character: '\u201D',
                title: t('ao')
            },
            {
                character: '\u201A',
                title: t('ap')
            },
            {
                character: '\u201E',
                title: t('aq')
            },
            {
                character: '\xA1',
                title: t('ar')
            },
            {
                character: '\xBF',
                title: t('as')
            },
            {
                character: '\u2025',
                title: t('at')
            },
            {
                character: '\u2026',
                title: t('au')
            },
            {
                character: '\u2021',
                title: t('av')
            },
            {
                character: '\u2030',
                title: t('aw')
            },
            {
                character: '\u2031',
                title: t('ax')
            },
            {
                character: '\u203C',
                title: t('ay')
            },
            {
                character: '\u2048',
                title: t('az')
            },
            {
                character: '\u2049',
                title: t('ba')
            },
            {
                character: '\u2047',
                title: t('bb')
            },
            {
                character: '\xA9',
                title: t('bc')
            },
            {
                character: '\xAE',
                title: t('bd')
            },
            {
                character: '\u2122',
                title: t('be')
            },
            {
                character: '\xA7',
                title: t('bf')
            },
            {
                character: '\xB6',
                title: t('bg')
            },
            {
                character: '\u204B',
                title: t('bh')
            }
        ]);
    }
}